import { post } from './apiService';

export const uploadFile = async function (data: any) {
  const resp = await post('/files', data);
  return resp;
};
